import {
  GOT_IT_CLICKED,
  SKIP_TOOLTIPS,
  SET_TOOLTIPS_DATA,
  TOOLTIPS_SKIPPED,
  LOAD_TOOLTIPS_DATA,
  LOAD_HELP_INTRO_DATA,
  CHANGE_HELP_INTRO_DATA,
} from './constants';

export const setTooltipsData = (dispatch, data) => {
  dispatch({
    type: SET_TOOLTIPS_DATA,
    steps: data.steps,
    skipped: data.skipped,
  });
};

export const gotItClicked = (dispatch, {page, steps}) => {
  dispatch({
    type: GOT_IT_CLICKED,
    page,
    steps,
  });
};

export const tooltipsSkipped = (dispatch, steps) => {
  dispatch({
    type: TOOLTIPS_SKIPPED,
    steps,
  });
};

export const skipTooltips = (dispatch) => dispatch({type: SKIP_TOOLTIPS});

export const loadTooltipsData = (dispatch) =>
  dispatch({
    type: LOAD_TOOLTIPS_DATA,
  });

export const loadHelpIntroData = (dispatch) =>
  dispatch({
    type: LOAD_HELP_INTRO_DATA,
  });

export const changeHelpIntroData = (dispatch, value) => {
  dispatch({
    type: CHANGE_HELP_INTRO_DATA,
    value,
  });
};
